<template>
  <div class="ui segments">
    <div class="ui segment">
      <div class="ui breadcrumb">
        <router-link :to="{name:'home'}" class="section">Sākums</router-link>
        <span class="divider">/</span>
        
        <!--
        <router-link v-if="this.selectedCategory.category" :to="{ name: 'goods' }" class="section">
          {{this.selectedCategory.category}}
        </router-link>
        <span class="divider">/</span>
        <router-link v-if="this.selectedCategory.categorya"  :to="{ name: 'goods' }" class="section">
          {{this.selectedCategory.categorya}}
        </router-link>
        <span class="divider">/</span>
        <router-link v-if="this.selectedCategory.categoryb"  :to="{ name: 'goods' }" class="section">
          {{this.selectedCategory.categoryb}}
        </router-link>
        <span v-if="this.selectedCategory.categoryb" class="divider">/</span>
        -->
        
        <div class="active section">Preces</div>
      </div>
    </div>

    <!-- <div class="ui attached segment">
      <div class=" section">Preces</div>
    </div> -->
    
    <div class="ui attached segment">
      <!-- cart icon -->
      <div class="fabContainer" v-if="itemsInCart>0">
        <div class="faButton" v-on:click="$router.push({name:'cart'})">
          <div class="fabb ui circular google plus icon button">
            <i class="cart icon"></i>
          </div>
        </div>
      </div>

      <category-menu @reload="checkreload"></category-menu>

      <div v-if="storeStatus.loading" class="ui active centered inline loader" style="padding:20px"></div>

      <div v-if="!storeStatus.loading && paginator" class="ui stackable three cards">

        <div v-for="(item,index) in goods" class="ui fluid card" style="position:relative; margin-right: 10px"
          :key="item.id" :id="item.id" :index="index"
          v-bind:class="[{complementary_view:in_complementary==item.id && complementary_index==index},{replacement_view:in_replacement==item.id && replacement_index==index}]">


          <div class="badges" style="display:inline-block;">
            <discount-tag style="display:inline-block;" v-bind:item="item"></discount-tag>
            <div v-for="badge in item.badges" :key="badge.id" class="ui labels" style="display:inline-block;">
              <a class="ui label" :style="{ backgroundColor: '#'+ badge.color, color: '#210404'}">{{badge.label}}</a>
            </div>
          </div>



          <!-- arrows -->
          <!-- <div v-if="outofstock===item.id">
            <i class="chevron left icon" style="left:0px;position:absolute;top:25%"></i>
            <i class="chevron right icon" style="top:0px;right:0px;position:absolute;top:25%"></i>
            </div>-->
          <!-- buttons -->
          <!-- <div v-if="item.alternative_goods.length>0 && show_complementary===item.id">
            </div>-->

          <!-- only show if in replacement -->

          <div style="position:relative;margin-left:10px;margin-right:11px;text-align: center;" class="img_height">

            <div v-if="in_complementary==item.id || in_replacement==item.id">
              <button :item-id="item.id" v-if="in_replacement==item.id && replacement_index==index "
                @click="replacement(index, item, -2)" class="circular ui icon button replacement close shadow">
                <div>
                  <span style="font-size:20px">
                    <!-- <strong v-if="item.related_goods!=null">{{item.related_goods.length}}</strong> -->
                    <strong>
                      <i class="close icon"></i>
                    </strong>
                  </span>
                  <span style="font-size:12px;word-break: break-all;display: block;margin-top: 5px;">
                    <small class="options">Līdzīgas preces</small>
                  </span>
                </div>
              </button>
              <!-- show only if in complementary  -->
              <button :item-id="item.id" v-if="in_complementary==item.id && complementary_index==index"
                @click.stop="complementary(index,item,-2)"
                class="circular ui icon custom_brown button complementary close shadow">
                <div>
                  <span style="font-size:20px">
                    <strong>
                      <i class="close icon"></i>
                    </strong>
                  </span>
                  <span>
                    <small class="options">Saistītās preces</small>
                  </span>
                </div>
              </button>
            </div>

            <div class="">
              <button
                v-if=" outofstock===item.id && !in_replacement && !in_complementary && replacement_array[0].length>0 && replacement_index==index"
                @click="replacement(index, item, 0)" class="circular ui icon button replacement shadow">
                <div>
                  <span style="font-size:30px">
                    <strong v-if="replacement_arrow[0].length>0">{{replacement_arrow[0].length}}</strong>
                    <strong style="font-size:15px; background-color:white" v-else>0</strong>
                  </span>
                  <span style>
                    <small class="options">Līdzīgas preces</small>
                  </span>
                </div>
              </button>

              <button v-for="result of show_complementary" :key="result"
                v-if="result==item.id && !in_replacement && !in_complementary && complementary_array[item.id].length>0 && complementary_index==index"
                @click.stop="complementary(index,item,0)" class="circular ui icon custom_brown button complementary shadow">
                <div>
                  <span style="font-size:30px">
                    <strong>{{complementary_array[item.id].length}}</strong>
                  </span>
                  <span>
                    <small class="options">Saistītās preces</small>
                  </span>
                </div>
              </button>
            </div>


            <!-- <img class="ui centered image" v-if="item.images[0]" :src="item.images[0].url">
            <img
              class="ui centered image"
              v-else
              :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.id+'.jpg'"
              >-->
            <!-- @click="$router.push('/good/'+item.link)" -->
            <v-touch :v-if="!in_complementary==item.id && !in_replacement==item.id">
              <v-touch v-bind:enabled="in_complementary==item.id" v-on:swiperight="complementary(index,item,-1)"
                v-on:swipeleft="complementary(index,item,1)">
                <v-touch v-bind:enabled=" in_replacement==item.id" v-on:swiperight="replacement(index,item,-1)"
                  v-on:swipeleft="replacement(index,item,1)">
                  <img @click.stop="$router.push('/good/'+item.link)" class="ui centered image"
                    v-if="item.images[0]" :src="item.images[0].url">
                  <img @click.stop="$router.push('/good/'+item.link)" class="ui centered image" v-else
                    :src="'https://res.cloudinary.com/mwsuite/image/upload/f_auto,w_170,h_250,c_lfill/product/'+item.id+'.jpg'">

                  <div
                    v-if="(in_complementary==item.id && complementary_index==index) || (in_replacement==item.id && replacement_index==index) ">
                    <a class="prev" style="left:0" v-if="in_complementary==item.id"
                      @click.stop="complementary(index,item,-1)">&#10094;</a>
                    <a class="prev" style="left:0" v-else-if="in_replacement==item.id"
                      @click.stop="replacement(index,item,-1)">&#10094;</a>
                    <a class="next" v-if="in_complementary==item.id"
                      @click.stop="complementary(index,item,1)">&#10095;</a>
                    <a class="next" v-else-if="in_replacement==item.id"
                      @click.stop="replacement(index,item,1)">&#10095;</a>
                  </div>
                </v-touch>
              </v-touch>
            </v-touch>
            <div v-if="in_complementary==item.id && complementary_index==index"
              v-for="complement_id of complementary_arrow[parent_item.id]" :key="complement_id" class="carousel-dots"
              style="display:inline-block">
              <span v-if="complement_id==item.id" class="dot active custom_dots"></span>
              <span v-else class="dot custom_dots"></span>
            </div>
            <div v-if="in_replacement==item.id && replacement_index==index" v-for="related_id of replacement_arrow[0]"
              :key="related_id" class="carousel-dots" style="display:inline-block;">
              <span v-if="related_id==item.id" class="dot active custom_dots"></span>
              <span v-else class="dot custom_dots"></span>
            </div>
          </div>
          <div v-if="(selectedCategory.categoryLink=='vairuma' || item.category_id.includes(7) || hasSale(item)) && item.expiry_date!=''" class="expiry-date">
            Derīgs līdz: {{item.expiry_date}}
          </div>
          <div v-else-if="(selectedCategory.categoryLink=='vairuma' || item.category_id.includes(7) || hasSale(item))" class="expiry-date">
            Derīgs līdz: skat. aprakstu zemāk
          </div>
          <div class="content">
            <router-link :to="'/good/'+item.link" style="margin-bottom:5px" class="header">{{item.goods_name}}
            </router-link>
            <div class="meta">
              <div class="ui tag labels pa-tag-wrapper">
                <price-tag v-bind:item="item"></price-tag>
                <a v-if="item.bail>0" class="ui green label">Drošības nauda: {{item.bail}} &euro;</a>
                <auto-ship v-bind:item="item"></auto-ship>
              </div>
              <div v-if="item.deposit != 0" class="deposit-info">
                + Depozīts: {{item.deposit}} &euro;
              </div>
            </div>
            <div class="description">{{item.description}}</div>
          </div>
          <button v-if="!checkIfInCart(item)" @click="addItemToCart(item,index)" class="ui bottom attached button" v-bind:class="{ loading: cartStoreStatus.loading, loading: cartStoreStatus.loading }">
            <i class="add icon"></i> Pievienot
          </button>
          <div v-else class="ui three bottom attached  buttons">
            <div class="ui button" @click="reduceItemInCart(item)" v-bind:class="{ loading: cartStoreStatus.loading, loading: cartStoreStatus.loading }">
              <i class="minus icon"></i>
            </div>
            <button v-on:click="$router.push({name:'cart'})" class="ui vertical animated button" v-bind:class="{ loading: cartStoreStatus.loading, loading: cartStoreStatus.loading }">
              <div class="ui hidden content">Uz grozu</div>
              <div class="ui visible content">
                <i class="cart icon"></i>
                {{howManyInCart(item)}} gab.
              </div>
            </button>
            <div class="ui button" @click="addItemToCart(item,index)" v-bind:class="{ loading: cartStoreStatus.loading, loading: cartStoreStatus.loading }">
              <i class="add icon popup out-of-stock-popup" :id="'good_item_'+item.id"
                data-content="Diemžēl pieejamo preču skaits noliktavā ir ierobežots, lūdzu apskatiet līdzīgās preces.">
              </i>
            </div>
          </div>
        </div>
        <div v-if="paginator && goods.length < 1">
          <div class="ui warning icon message">
            <i class="info circle icon"></i>
            <div class="content">
              <div class="header">Nekas netika atrasts!</div>
              <p>
                Izmaini meklēšanas kritērijus vai arī
                <a style="cursor:pointer" @click="resetFilters">noņemt visus filtrus</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui clearing segment">
      <div style="float:right">
        <paginator :paginator="paginator" link-name=""></paginator>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import CategoryMenu from "./CategoryMenu";
  import Paginator from "./GoodsPaginator";
  import autoShip from "./AutoShip";
  import price from "./Price";
  import discount from "./Discount";
  import api from "../store/api";
  //import Vue from 'vue';


  export default {
    components: {
      CategoryMenu,
      Paginator,
      "auto-ship": autoShip,
      "price-tag": price,
      "discount-tag": discount,
      //"good-card": goodcard
    },
    data() {
      return {
        page: 1,
        //isactive: false,
        //complementary_view: null,
        //replacement_view: null,
        replacement_index: "",
        complementary_index: "",
        outofstock: "", // turn on replacement button view on
        in_complementary: null, //check if browsing complementary goods
        in_replacement: null, //check if browsing replacement goods
        complementary_array: [], //array of  complementary goods
        replacement_array: [], //array of  replacemet goods
        parent_item: {}, //keep track of first element before browsing complementary and replacement goods
        complementary_arrow: [], // hold complementary goods id
        replacement_arrow: [], // hold replacement goods id
        show_complementary: [] // turn on complementary button view  for the specific good
      };
    },
    computed: {
      cart() {
        return this.$store.state.cartStore.activeCart;
      },
      cartStoreStatus() {
        return this.$store.state.cartStore.status
      },
      cartItems() {
        return this.$store.state.cartStore.items;
      },
      goods() {
        //console.log(this.$store.state.goodStore.items);
        return this.$store.state.goodStore.items;
      },
      storeStatus() {
        return this.$store.state.goodStore.status;
      },
      paginator() {
        return this.$store.state.goodStore.goodsExtraData;
      },
      searchTerm() {
        return this.$store.state.categoryStore.searchTerm;
      },
      itemsInCart() {
        const sumValues = Object.keys(this.$store.state.cartStore.items).reduce(
          (acc, value) =>
            acc + parseInt(this.$store.state.cartStore.items[value].order),
          0
        );
        return sumValues;
      },
      selectedCategory() {
        return this.$store.state.categoryStore.selectedCategory;
      },
      categories() {
        return this.$store.state.categoryStore.items;
      }
    },
    activated: function () {
      //this.isactive = true; //used to ensure that when route keeps changing we dont reload data while component is not visible
      //preload data
      this.loadActiveCart();
      //if (!this.goods.length || this.goods.length == 0) this.loadGoods();
      this.loadGoods();
	  
      window.removeEventListener('scroll', this.handleScroll);
      var header = document.querySelector('#fixed-header');
      if (header) header.style.top = '-100px';
    },
    deactivated: function () {
      //this.isactive = false;
      this.outofstock = "";
      this.in_complementary = null;
      this.in_replacement = null;
    },
    watch: {
      //"$route.params": "loadGoods",
      //searchTerm: "searchForGoods",
      //selectedCategory: 'exitall',
    },
    methods: {
      checkreload(value) {
        this.in_complementary = null;
        this.in_replacement = null;
      },
      loadActiveCart: function () {
        this.$store
          .dispatch("loadActiveCart")
          .then(response => {
            this.$store.dispatch("loadCartItems", this.cart.id);
          })
          .catch(error => {
            if (error.response.status == 404) {
              //if there is no active cart then create new cart
              this.$store.dispatch("createCart");
            }
          });
      },

      loadGoods() {
        //as this is called by watcher then first check if component is activated
        var page = this.$route.params.page ? this.$route.params.page : 1;
        
        //slugs
        var categoryLink = this.$route.params.categorylink ? this.$route.params.categorylink : '';
        var categoryaLink = this.$route.params.categoryalink ? this.$route.params.categoryalink : '';
        var categorybLink = this.$route.params.categoryblink ? this.$route.params.categoryblink : '';
        
        var c = 0, a = 0, b = 0;
        var category = this.selectedCategory.category, categorya = this.selectedCategory.categorya, categoryb = this.selectedCategory.categoryb;
        
        //if slugs provided iterate through all categories and find correct ids
        //if (categoryLink != '') {
        //  for (c = 0; c < this.categories.length; c++) {
        //    if (this.categories[c].link == categoryLink) {
        //      category = this.categories[c].id;
        //      if (categoryaLink != '' && this.categories[c].category_a.length > 0) {
        //        for (a = 0; a < this.categories[c].category_a.length; a++) {
        //          if (this.categories[c].category_a[a].link == categoryaLink) {
        //            categorya = this.categories[c].category_a[a].id;
        //            if (categorybLink != '' && this.categories[c].category_a[a].category_b.length > 0) {
        //              for (b = 0; b < this.categories[c].category_a[a].category_b.length; b++) {
        //                if (this.categories[c].category_a[a].category_b[b].link == categorybLink) {
        //                  categoryb = this.categories[c].category_a[a].category_b[b].id;
        //                }
        //              }
        //            }
        //          }
        //        }
        //      }
        //    }
        //  }
        //}
        if (categoryLink != '') {
          this.categories.forEach(function(item) {
            if (item.link == categoryLink) {
              category = item.id;
              if (categoryaLink != '' && item.category_a.length > 0) {
                item.category_a.forEach(function(itema) {
                  if (itema.link == categoryaLink) {
                    categorya = itema.id;
                    if (categorybLink != '' && itema.category_b.length > 0) {
                      itema.category_b.forEach(function(itemb) {
                        if (itemb.link == categorybLink) {
                          categoryb = itemb.id;
                        }
                      });
                    }
                  }
                });
              }
            }
          });
        }
        
        this.$store.commit({
          type: 'SET_SELECTED_CATEGORY',
          category: category,
          categorya: categorya,
          categoryb: categoryb,
          categoryLink: categoryLink,
          categoryaLink: categoryaLink,
          categorybLink: categorybLink
        });
        
        //if (this.isactive)
        this.$store.dispatch("loadGood", [
          page,
          this.searchTerm,
          category,
          categorya,
          categoryb
        ]).then(response => {
        }).catch(error => {
          console.log('Error');
        });
      },

      searchForGoods() {
        //check if user started to search and he is yes then move to first page so that we can show items
        if (this.$route.params.page > 1) {
          this.$router.push({
            name: "goods"
          });
        }
        this.loadGoods();
      },

      checkIfInCart(item) {
        if (
          this.$store.state.cartStore.items.length > 0 &&
          this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          }).length > 0
        )
          return true;
        else return false;
      },

      howManyInCart(item) {
        if (this.checkIfInCart(item)) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          });
          item.autoship_price = cartItem[0].autoship_price;
          return cartItem[0].order;
        } else return 0;
      },

      realPrice(item) {
        if (this.checkIfInCart(item)) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          });
          return cartItem[0].price_vat;
        } else return item.base_price_vat;
      },

      gotoCart() {
        this.$router.push({
          name: "cart"
        });
      },

      //get the complementary items if available
      get_complementary(item, index) {
        var complementary_id = item.alternative_goods;
        var complementary_goods = [];
        var comp_arrow = [];
        if (complementary_id.length > 0) {
          complementary_id.forEach(function (id) {
            api.get("goods/" + id).then(function (response) {
              if (response.data.data.check_in_warehouse == 1) {
                if (response.data.data.available_for_customer > 0) {
                  complementary_goods.push(response.data.data);
                  comp_arrow.push(response.data.data.id);
                }
              }
              else {
                complementary_goods.push(response.data.data);
                comp_arrow.push(response.data.data.id);
              }
            });
          });
          this.complementary_arrow[item.id] = comp_arrow;
          this.complementary_array[item.id] = complementary_goods;
          this.complementary_array.splice(item.id, 1, complementary_goods);
          //console.log(this.complementary_array[item.id]);
        }
      },
      //get the replacement items if available
      get_replacement(item, index) {
        var replacement_id = item.related_goods;
        var replacement_goods = [];
        var replace_arrow = [];
        //console.log(replacement_id);
        if (replacement_id.length > 0) {
          replacement_id.forEach(function (id) {
            api.get("goods/" + id).then(function (response) {
              //console.log(response.data.data);
              if (response.data.data.check_in_warehouse) {
                if (response.data.data.available_for_customer > 0) {
                  replacement_goods.push(response.data.data);
                  replace_arrow.push(response.data.data.id);
                }
              }
              else {
                replacement_goods.push(response.data.data);
                replace_arrow.push(response.data.data.id);
              }
            });
          });
          this.replacement_arrow.splice(0, 1, replace_arrow);
          this.replacement_array.splice(0, 1, replacement_goods);
          // console.lconsole.log(this.replacement_array[0]);
        }
      },

      //traverse replacement items while browsing
      replacement(index, item, position) {
        let array_index = 0;
        if (position == 0) {
          this.parent_item = item;
          this.replacement_view = index;
          this.in_replacement = this.replacement_array[0][array_index].id;
          this.goods.splice(index, 1, this.replacement_array[0][array_index]);
        }
        if (position == 1) {
          array_index =
            this.replacement_array[0].findIndex(x => x.id == item.id) + 1;
          this.in_replacement = this.replacement_array[0][array_index].id;
          this.goods.splice(index, 1, this.replacement_array[0][array_index]);
        }
        if (position == -1) {
          array_index =
            this.replacement_array[0].findIndex(x => x.id == item.id) - 1;
          this.in_replacement = this.replacement_array[0][array_index].id;
          this.goods.splice(index, 1, this.replacement_array[0][array_index]);
        }
        if (position == -2) {
          this.replacement_view = null;
          this.goods.splice(index, 1, this.parent_item);
          this.in_replacement = null;
        }
      },

      //traverse complementary items while browsing
      complementary(index, item, position) {
        let array_index = 0;
        if (position == 0) {
          this.parent_item = item;
          this.complementary_view = index;
          this.in_complementary = this.complementary_array[this.parent_item.id][array_index].id;
          this.goods.splice(index, 1, this.complementary_array[this.parent_item.id][array_index]);
        }
        if (position == 1) {
          array_index = this.complementary_array[this.parent_item.id].findIndex(
            x => x.id == item.id
          );
          array_index = array_index + 1;
          this.in_complementary = this.complementary_array[this.parent_item.id][array_index].id;
          this.goods.splice(index, 1, this.complementary_array[this.parent_item.id][array_index]);
        }
        if (position == -1) {
          array_index =
            this.complementary_array[this.parent_item.id].findIndex(x => x.id == item.id) - 1;
          this.in_complementary = this.complementary_array[this.parent_item.id][array_index].id;
          this.goods.splice(index, 1, this.complementary_array[this.parent_item.id][array_index]);
        }
        if (position == -2) {
          this.complementary_view = null;
          this.goods.splice(index, 1, this.parent_item);
          this.in_complementary = null;
        }
      },

      addItemToCart(item, index) {
        var itemInCart = this.checkIfInCart(item);
        if (itemInCart) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          });
          var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
          updatedItem.order++;
        } else {
          var updatedItem = {
            order: (this.$store.state.categoryStore.selectedCategory.categoryLink == 'vairuma') ? item.best_price_no_required : 1,
            good_id: item.id
          };
        }
        // console.log("updatedItem at GoodsPage",updatedItem);
        // console.log("this.cart.id, at GoodPage", this.cart.id)
        //inform facebook
        this.$store
          .dispatch("addCartItem", [this.cart.id, updatedItem])
          .then(response => {
            // console.log("response at goodsPage: ", response)

            if (
              item.alternative_goods != null &&
              item.alternative_goods.length > 0 &&
              item.check_in_warehouse == 1
            ) {
              //find if id is present in array
              if (item.available_for_customer > 0) {
                if (!this.show_complementary.includes(item.id)) {
                  this.show_complementary.push(item.id);
                }
                this.complementary_index = index;
                this.get_complementary(item, index);
              }
            } else if (item.alternative_goods != null &&
              item.alternative_goods.length > 0 &&
              item.check_in_warehouse == 0) {
              if (!this.show_complementary.includes(item.id)) {
                this.show_complementary.push(item.id);
                this.complementary_index = index;
                this.get_complementary(item, index);
              }
            }
            if (item.id) item.autoship_price = response.data.data.autoship_price;
            //show popup that we are out of good
            if (response.data.data.order < updatedItem.order) {
              console.log("item out of stock");
              // setTimeout(function () {
              // if (item.id != $(".close").attr("item-id")) {
              //   $(".close").trigger("click");
              // }
              if (item.related_goods.length < 1 && item.alternative_goods.length < 1) {
                let outOfStockMessage = "Diemžēl noliktavā šobrīd šīs preces nav. Drīzumā plānojam to saņemt. Ja preču atlikums ir 0, tad reģistrētam klientam - tiklīdz prece atkal būs pieejama, tiks automātiski nosūtīts paziņojums uz e-pastu!"
                $("#good_item_" + item.id).attr('data-content', outOfStockMessage);
              }


              $("#good_item_" + item.id).popup("show");
              // setTimeout(
              //   function () {
              //     $("#good_item_" + item.id).popup("destroy");
              //   }.bind(this),
              //   10000
              // );
              // }, 1000);
              if (item.related_goods != null && item.related_goods.length > 0) {
                this.outofstock = item.id;
                this.replacement_index = index;
                this.get_replacement(item, index);
              } else {
                let outOfStockMessage = "Diemžēl noliktavā šobrīd šīs preces nav. Drīzumā plānojam to saņemt. Ja preču atlikums ir 0, tad reģistrētam klientam - tiklīdz prece atkal būs pieejama, tiks automātiski nosūtīts paziņojums uz e-pastu!"

                $("#good_item_" + item.id).attr('data-content', outOfStockMessage);

                
                $("#good_item_" + item.id).popup("show");
                // setTimeout(
                //   function () {
                //     $("#good_item_" + item.id).popup("destroy");
                //   }.bind(this),
                //   5000
                // );
              }
            }
            else {
              //this.$store.dispatch("loadActiveCart", this.cart.id);
            }
            fbq("track", "AddToCart", {
              content_name: response.data.data.name,
              content_category: "Water",
              content_ids: [response.data.data.good_id],
              content_type: "product",
              value: response.data.data.price_vat,
              currency: "EUR"
            });
          })
          .catch(error => {
            console.error("Cart was not loaded at GoodsPage. With error: ", error);
          });
      },

      reduceItemInCart(item) {

        $("#good_item_" + item.id).popup("destroy"); //remove warning about warehouse goods
        var itemInCart = this.checkIfInCart(item);
        if (itemInCart) {
          var cartItem = this.$store.state.cartStore.items.filter(function (e) {
            return e.good_id == item.id;
          });

          var updatedItem = JSON.parse(JSON.stringify(cartItem[0])); //copy object
          updatedItem.order--;
          //console.log(updatedItem);
          this.$store
            .dispatch("addCartItem", [this.cart.id, updatedItem])
            .then(response => {
              item.autoship_price = response.data.data.autoship_price;
              //if item is totaly removed then remove it from store
              this.$store.dispatch("loadActiveCart", this.cart.id);
              this.outofstock = "";
            })
            .catch(error => {
              console.error("Cart was not loaded");
            });
        }
      },

      resetFilters() {
        //reset filter
        this.$store.commit("SET_CATEGORY_SEARCH_TERM", ""); //will trigger loading of goods
        //this.loadGoods()
      },
	  
      hasSale(item) {
        return parseFloat(item.base_price_old_vat) > parseFloat(item.base_price_vat);
      }
    }
  };
</script>
<style>
  .out-of-stock-popup {
    height: 100% !important;
    width: 100% !important;
    visibility: visible;
  }


  .custom_dots {
    height: 10px !important;
    width: 10px !important;

  }

  .product-image {
    height: 280px !important;
    margin-top: 1px !important;
    margin-bottom: 1px !important;
  }
  
  .expiry-date {
    font-size: 1em;
    color: rgba(0, 0, 0, 0.68);
    padding: 1em;
  }
  
  .deposit-info {
    font-size: 1em;
    color: rgba(0, 0, 0, 0.4);
  }

  .complementary_view {
    border: 2px solid custom_brown !important;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) !important;
  }

  .replacement_view {
    border: 2px solid #f7931e !important;
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0) !important;
  }

  .replacement {
    background-color: #f7931e !important;
    color: white !important;
    width: 80px;
    height: 80px;
    position: absolute;
    left: 3px;
    top: 60%;
    z-index: 2;
  }

  .complementary {
    background-color: #c1272d !important;
    color: white !important;
    float: left;
    width: 80px;
    height: 80px;
    position: absolute;
    right: 0px;
    top: 60%;
    z-index: 2;
  }

  .next-prev {
    position: absolute;
    top: 20%;
    z-index: 1;
  }

  .options {
    font-size: 14px;
    word-break: break-all;
    display: block;
    margin-top: 5px;
  }

  .fabContainer {
    position: fixed;
    margin-left: 1086px;
    bottom: 50px;
    background: none;
    border: none;
    text-align: right;
    z-index: 10;
  }

  .fabb.button {
    font-size: 1.5rem !important;
  }

  @media (max-width: 767px) {
    .fabContainer {
      right: 0px;
    }
  }

  @media (min-width: 768px) {
    .fabContainer {
      margin-left: 675px;
    }
  }

  @media (min-width: 992px) {
    .fabContainer {
      margin-left: 895px;
    }
  }

  @media (min-width: 1260px) {
    .fabContainer {
      margin-left: 1086px;
    }
  }

  @media (min-width: 1280px) {
    .fabContainer {
      margin-left: 1086px;
    }
  }

  .badge-wrapper {
    position: relative;
    display: flex;
    top: 0;
  }

  .mySlides {
    display: none;
  }

  .mySlides1 {
    display: block;
  }

  img {
    vertical-align: middle;
  }

  /* Slideshow container */
  .slideshow-container {
    max-width: 1000px;
    position: relative;
    margin: auto;
  }

  /* Next & previous buttons */
  .prev,
  .next {
    cursor: pointer;
    position: absolute;
    top: 40%;
    width: auto;
    padding: 16px;
    margin-top: -22px;
    font-weight: bold;
    font-size: 18px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;
    color: #bbb;
  }

  /* Position the "next button" to the right */
  .next {
    right: 0;
    border-radius: 3px 0 0 3px;
  }

  /* On hover, add a black background color with a little bit see-through */
  .prev:hover,
  .next:hover {
    color: rgba(0, 0, 0, 0.8);
  }

  /* The dots/bullets/indicators */
  .carousel-dots {
    text-align: center;
    margin: 15px auto;
  }

  .dot {
    cursor: pointer;
    height: 15px;
    width: 15px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;
  }

  /* On smaller screens, decrease text size */
  @media only screen and (max-width: 300px) {

    .prev,
    .next,
    .text {
      font-size: 11px;
    }
  }

  .owl-carousel {
    display: none;
    width: 100%;
    -webkit-tap-highlight-color: transparent;
    /* position relative and z-index fix webkit rendering fonts issue */
    position: relative;
    z-index: 1;
  }

  .owl-carousel .owl-stage {
    position: relative;
    -ms-touch-action: pan-Y;
    touch-action: manipulation;
    -moz-backface-visibility: hidden;
    /* fix firefox animation glitch */
  }

  .owl-carousel .owl-stage:after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
  }

  .owl-carousel .owl-stage-outer {
    position: relative;
    overflow: hidden;
    /* fix for flashing background */
    -webkit-transform: translate3d(0px, 0px, 0px);
  }

  .owl-carousel .owl-wrapper,
  .owl-carousel .owl-item {
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
    -ms-backface-visibility: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    -moz-transform: translate3d(0, 0, 0);
    -ms-transform: translate3d(0, 0, 0);
  }

  .owl-carousel .owl-item {
    position: relative;
    min-height: 1px;
    float: left;
    -webkit-backface-visibility: hidden;
    -webkit-tap-highlight-color: transparent;
    -webkit-touch-callout: none;
  }

  .owl-carousel .owl-item img {
    display: block;
    width: 100%;
  }

  .owl-carousel .owl-nav.disabled,
  .owl-carousel .owl-dots.disabled {
    display: none;
  }

  .owl-carousel .owl-nav .owl-prev,
  .owl-carousel .owl-nav .owl-next,
  .owl-carousel .owl-dot {
    cursor: pointer;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .owl-carousel .owl-nav button.owl-prev,
  .owl-carousel .owl-nav button.owl-next,
  .owl-carousel button.owl-dot {
    background: none;
    color: inherit;
    border: none;
    padding: 0 !important;
    font: inherit;
  }

  .owl-carousel.owl-loaded {
    display: block;
  }

  .owl-carousel.owl-loading {
    opacity: 0;
    display: block;
  }

  .owl-carousel.owl-hidden {
    opacity: 0;
  }

  .owl-carousel.owl-refresh .owl-item {
    visibility: hidden;
  }

  .owl-carousel.owl-drag .owl-item {
    -ms-touch-action: pan-y;
    touch-action: pan-y;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .owl-carousel.owl-grab {
    cursor: move;
    cursor: grab;
  }

  .owl-carousel.owl-rtl {
    direction: rtl;
  }

  .owl-carousel.owl-rtl .owl-item {
    float: right;
  }

  /* No Js */
  .no-js .owl-carousel {
    display: block;
  }

  /*
 *  Owl Carousel - Animate Plugin
 */
  .owl-carousel .animated {
    animation-duration: 1000ms;
    animation-fill-mode: both;
  }

  .owl-carousel .owl-animated-in {
    z-index: 0;
  }

  .owl-carousel .owl-animated-out {
    z-index: 1;
  }

  .owl-carousel .fadeOut {
    animation-name: fadeOut;
  }

  @keyframes fadeOut {
    0% {
      opacity: 1;
    }

    100% {
      opacity: 0;
    }
  }

  .shadow {
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12) !important;
  }

  /*
 *     Owl Carousel - Auto Height Plugin
 */
  .owl-height {
    transition: height 500ms ease-in-out;
  }

  /*
 *     Owl Carousel - Lazy Load Plugin
 */
  .owl-carousel .owl-item {
    /**
            This is introduced due to a bug in IE11 where lazy loading combined with autoheight plugin causes a wrong
            calculation of the height of the owl-item that breaks page layouts
         */
  }

  .owl-carousel .owl-item .owl-lazy {
    opacity: 0;
    transition: opacity 400ms ease;
  }

  .owl-carousel .owl-item .owl-lazy[src^=""],
  .owl-carousel .owl-item .owl-lazy:not([src]) {
    max-height: 0;
  }

  .owl-carousel .owl-item img.owl-lazy {
    transform-style: preserve-3d;
  }

  /*
 *     Owl Carousel - Video Plugin
 */
  .owl-carousel .owl-video-wrapper {
    position: relative;
    height: 100%;
    background: #000;
  }

  .owl-carousel .owl-video-play-icon {
    position: absolute;
    height: 80px;
    width: 80px;
    left: 50%;
    top: 50%;
    margin-left: -40px;
    margin-top: -40px;
    cursor: pointer;
    z-index: 1;
    -webkit-backface-visibility: hidden;
    transition: transform 100ms ease;
  }

  .owl-carousel .owl-video-play-icon:hover {
    -ms-transform: scale(1.3, 1.3);
    transform: scale(1.3, 1.3);
  }

  .owl-carousel .owl-video-playing .owl-video-tn,
  .owl-carousel .owl-video-playing .owl-video-play-icon {
    display: none;
  }

  .owl-carousel .owl-video-tn {
    opacity: 0;
    height: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    transition: opacity 400ms ease;
  }

  .owl-carousel .owl-video-frame {
    position: relative;
    z-index: 1;
    height: 100%;
    width: 100%;
  }

  .owl-theme .owl-nav {
    margin-top: 10px;
    text-align: center;
    -webkit-tap-highlight-color: transparent;
  }

  .owl-theme .owl-nav [class*="owl-"] {
    color: #fff;
    font-size: 14px;
    margin: 5px;
    padding: 4px 7px;
    background: #d6d6d6;
    display: inline-block;
    cursor: pointer;
    border-radius: 3px;
  }

  .owl-theme .owl-nav [class*="owl-"]:hover {
    background: #869791;
    color: #fff;
    text-decoration: none;
  }

  .owl-theme .owl-nav .disabled {
    opacity: 0.5;
    cursor: default;
  }

  .owl-theme .owl-nav.disabled+.owl-dots {
    margin-top: 10px;
  }

  .owl-theme .owl-dots {
    text-align: center;
    -webkit-tap-highlight-color: transparent;
  }

  .owl-theme .owl-dots .owl-dot {
    display: inline-block;
    zoom: 1;
    *display: inline;
  }

  .owl-theme .owl-dots .owl-dot span {
    width: 10px;
    height: 10px;
    margin: 5px 7px;
    background: #d6d6d6;
    display: block;
    -webkit-backface-visibility: visible;
    transition: opacity 200ms ease;
    border-radius: 30px;
  }

  .owl-theme .owl-dots .owl-dot.active span,
  .owl-theme .owl-dots .owl-dot:hover span {
    background: #869791;
  }

  .img_height {
    height: 280px;
  }

  .btnpossition {
    position: absolute;
    bottom: 30px;
    right: 15px;
  }
</style>


// WEBPACK FOOTER //
// GoodsPage.vue?051e7bf6